import {
	MetadataType,
	MetadataNoValueTypes,
	MetadataSingleValueTypes,
} from './constants';
import {metadataRuleDefaults} from './defaults';
import {MetadataRule} from './types';
import {metadataNameHackOut} from './utils';

type DoesNotRequireValue = typeof MetadataNoValueTypes[number];
type RequiresSingleValue = typeof MetadataSingleValueTypes[number];

type MetadataRuleBaseParams<
	T extends MetadataType = MetadataType.MATCH_ALL_WILD_CARDS,
> = {
	type?: T;
	name: string;
} & ([T] extends [MetadataType.MATCH_ANY_RANGE]
	? {
			/** range start value */
			rangeStart: string;
			/** range end value */
			rangeEnd: string;
	  }
	: [T] extends [RequiresSingleValue]
	? {
			/** attribute value */
			value: string;
	  }
	: {});

type Range = MetadataRuleBaseParams<MetadataType.MATCH_ANY_RANGE>;
type SingleValue = MetadataRuleBaseParams<RequiresSingleValue>;
type NoValue = MetadataRuleBaseParams<DoesNotRequireValue>;

type GetMetadataRuleParams = Range | SingleValue | NoValue;

// single value needed
export function createMetadataRule(
	params: SingleValue,
): MetadataRule<RequiresSingleValue>;

// range needed
export function createMetadataRule(
	params: Range,
): MetadataRule<MetadataType.MATCH_ANY_RANGE>;

// no value needed
export function createMetadataRule(
	params: NoValue,
): MetadataRule<DoesNotRequireValue>;

export function createMetadataRule(params: GetMetadataRuleParams) {
	const {name, type} = params;

	return {
		...metadataRuleDefaults,
		elementSubType1: type,
		/** value/range start */
		elementValue1:
			type === MetadataType.MATCH_ANY_RANGE
				? params.rangeStart
				: MetadataSingleValueTypes.includes(
						type as typeof MetadataSingleValueTypes[number],
				  )
				? (params as SingleValue).value
				: '',
		/** attribute name */
		elementValue2: metadataNameHackOut(name),
		/** range end */
		elementValue3: type === MetadataType.MATCH_ANY_RANGE ? params.rangeEnd : '',
	};
}

export default createMetadataRule;
